// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBAi0mbDgHdoK-LVqBVQQe96rDudWbPSqg",
  authDomain: "hotflix-ai.firebaseapp.com",
  projectId: "hotflix-ai",
  storageBucket: "hotflix-ai.appspot.com",
  messagingSenderId: "711535114159",
  appId: "1:711535114159:web:ecb5f79d59463cb0e4615a",
};

// Initialize Firebase
initializeApp(firebaseConfig);
export const auth = getAuth();
